import React, {Component} from 'react';
import './style.css';
import {translateRoute} from "../../../constants/traductions";
import {connect} from "react-redux";

const trip_list = [
  {id: 0, name: 'MACHUPICCHU'},
  // {id: 1, name: 'MACHUPICCHU + MONTAÑA WAYNAPICCHU'},
  // {id: 2, name: 'MACHUPICCHU + MONTAÑA MACHUPICCHU'},
  {id: 3, name: 'Camino Inka - Rutas 01, 02 y 03'},
  {id: 4, name: 'Camino Inka - Ruta 05'},

  {id: 5, name: 'Circuito 4 + Montaña Waynapicchu'},
  {id: 6, name: 'Montaña Machupicchu + Circuito 3'},
  {id: 7, name: 'Circuito 4 + Montraña Huchuypicchu'},
  {id: 8, name: 'Circuito 1, 2 + Puente Inka'},
];

class TripList extends Component {

  selectTrip(tname) {

    this.props.parentCallback(tname);

  }

  render() {

    return (

      <div className="info-trips">

        {trip_list.map(trip =>
          <div className="btn-trip-name" key={trip.id} onClick={() => this.selectTrip(trip)}>

            <p className="subheading">
              { translateRoute(trip.id, this.props.store.language) }
            </p>

          </div>
        )}

      </div>

    );

  }

}

const mapStateToProps = store => ({
  store
});

export default connect(mapStateToProps, null)(TripList);
